/*eslint-disable*/
import React from 'react'
import { toast } from 'react-toastify'

//components
import { Chip } from '@mui/material'
import { Box } from '@mui/system'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

// constants
import { MAX_ALLOWED_USERS } from '../membersTable/membersTable.constants'

// styles
import styles from './viewMembers.module.scss'

const renderChip = ({ selectedMember, handleDelete }) => (
  <Chip
    label={selectedMember?.display || selectedMember?.value}
    onDelete={() => handleDelete(selectedMember?.value)}
    className={styles.chipClass}
    variant="outlined"
    deleteIcon={
      <CloseOutlinedIcon
        sx={{
          color: '#000000 !important',
          fontSize: '16px !important',
          marginBottom: '-1px !important',
        }}
      />
    }
  />
)

const ViewMembers = ({
  selectedMembers = [],
  setSelectedMembers,
  getSelectedMembersCount,
  initialMembers = [],
}) => {
  const handleDelete = (deletedMemberId) => {
    const updatedSelectedMembers = selectedMembers.filter(
      (selectedMember) => selectedMember?.value !== deletedMemberId
    )
    const selectedMembersCount = getSelectedMembersCount(updatedSelectedMembers)
    if (selectedMembersCount > MAX_ALLOWED_USERS) {
      toast.warning(
        `You cannot add/remove more than ${MAX_ALLOWED_USERS} users`
      )
    } else {
      setSelectedMembers(updatedSelectedMembers)
    }
  }

  const filteredMembers = selectedMembers.filter(
    (member) => !initialMembers.some((init) => init?.value === member?.value)
  )

  return (
    <>
      {filteredMembers?.length > 0 && (
        <Box className={styles.gridClass}>
          {filteredMembers.map((selectedMember) =>
            renderChip({ selectedMember, handleDelete })
          )}
        </Box>
      )}
    </>
  )
}

export default ViewMembers
